declare global {
  interface Window {
    __bypassUnloadWarning?: boolean
  }
}

export const preventDefault =
  <T extends React.SyntheticEvent, R>(f: (e: T) => R) =>
  (e: T): R => {
    e.preventDefault()
    return f(e)
  }

export const preventDefaultAndValidate =
  <T extends React.SyntheticEvent, R>(f: (e: T) => R) =>
  (e: T): R | void => {
    e.preventDefault()
    const form = e.currentTarget.closest('form')
    if (!form || !form.reportValidity()) {
      return
    }
    return f(e)
  }

export class ApiError extends Error {
  response: any
  constructor(message, response) {
    super(message)
    this.response = response
  }
}

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

// mockable
export const Navigation = {
  navigate: (url: string) => {
    // Always bypass beforeunload warning for intentional navigation
    window.__bypassUnloadWarning = true
    window.location.href = url
  },
}
